var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socket",class:_vm._f("kebab")([_vm.type, _vm.socket.name, _vm.isConnected ? 'connected' : 'unconnected']),attrs:{"title":_vm.socket.name}})}
var staticRenderFns = []

export { render, staticRenderFns }